<h3>Astrowetter</h3>
<div class="sonstiges-wetter-container">
  <div class="sonstiges-wetter-border-container">
    <span class="sonstiges-wetter-subtitle">Mondphase</span>
    <div *ngFor="let phase of astrowetter.mondphase">
      <p class="sonstiges-wetter-paragraph">{{phase}}</p>
    </div>
  </div>

  <h3>Werte ({{astrowetter.update}})</h3>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">

    <ng-container matColumnDef="datum">
      <th mat-header-cell *matHeaderCellDef>Datum</th>
      <td mat-cell *matCellDef="let element">{{element?.datum}}</td>
    </ng-container>

    <ng-container matColumnDef="daemmerung">
      <th mat-header-cell *matHeaderCellDef>Dämmerung</th>
      <td mat-cell *matCellDef="let element">{{element?.daemmerung.wert}} {{element.daemmerung.einheit}}</td>
    </ng-container>

    <ng-container matColumnDef="meridian">
      <th mat-header-cell *matHeaderCellDef>Meridian</th>
      <td mat-cell *matCellDef="let element">{{element?.meridian.wert}} {{element.meridian.einheit}}</td>
    </ng-container>

    <ng-container matColumnDef="mondaufgang">
      <th mat-header-cell *matHeaderCellDef>Mondaufgang</th>
      <td mat-cell *matCellDef="let element">{{element?.mondaufgang.wert}} {{element.mondaufgang.einheit}}</td>
    </ng-container>

    <ng-container matColumnDef="monduntergang">
      <th mat-header-cell *matHeaderCellDef>Monduntergang</th>
      <td mat-cell *matCellDef="let element">{{element?.monduntergang.wert}} {{element.monduntergang.einheit}}</td>
    </ng-container>

    <ng-container matColumnDef="sonnenaufgang">
      <th mat-header-cell *matHeaderCellDef>Sonnenaufgang</th>
      <td mat-cell *matCellDef="let element">{{element?.sonnenaufgang.wert}} {{element.sonnenaufgang.einheit}}</td>
    </ng-container>

    <ng-container matColumnDef="sonnenuntergang">
      <th mat-header-cell *matHeaderCellDef>Sonnenuntergang</th>
      <td mat-cell *matCellDef="let element">{{element?.sonnenuntergang.wert}} {{element.sonnenuntergang.einheit}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns" sticky></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

</div>
